export const SESSION_REFRESH_FAILED = "Couldn't refresh your session. Check your connection and try again.";

/**
 * Token refresh did not produce a usable session: Identity rejected it (the session is already gone) or did not answer
 * (the session stays). Reads do not retry it and `DataService.handleError` shows no toast for it — IdentityService has
 * already shown the one message.
 */
export class SessionRefreshError extends Error {
  constructor() {
    super(SESSION_REFRESH_FAILED);
    this.name = 'SessionRefreshError';
  }
}
